import React, { useCallback, useEffect, useState } from 'react';
import { DescriptionCompleter } from './description-completer/index.tsx';
import type { Props } from './types.tsx';
import {
	isConfluenceLink,
	generatePayloadForProactiveDescriptionCompleter,
	triggerEditorStreamHubEvent,
} from './utils.tsx';

import { useProactiveDescriptionCompleterStore } from './store.tsx';

export const AiProactiveDescriptionCompleter = (props: Props) => {
	const { editorApi } = props;
	const [showFooter, setShowFooter] = useState(false);
	const [currentCard, setCurrentCard] = useState<{ title?: string; url?: string } | undefined>();

	const [, { setProactiveDescriptionCompleterPayload, resetProactiveDescriptionCompleterPayload }] =
		useProactiveDescriptionCompleterStore();

	const onProactiveDescriptionCompleterFooterClick = useCallback(() => {
		setProactiveDescriptionCompleterPayload(
			generatePayloadForProactiveDescriptionCompleter(currentCard?.url),
		);
		triggerEditorStreamHubEvent();
	}, [setProactiveDescriptionCompleterPayload, currentCard]);

	useEffect(() => {
		// tracking the shared card state plugin
		// determines whether the AI suggest button should be shown or not
		const unsub = editorApi?.card?.sharedState.onChange(({ nextSharedState, prevSharedState }) => {
			if (prevSharedState?.cards.length === nextSharedState?.cards.length) {
				return;
			}
			if (prevSharedState?.cards.length !== 0 || nextSharedState?.cards.length !== 1) {
				setShowFooter(false);
				return;
			}
			const [{ url, title }] = nextSharedState.cards;
			const hasAccess = url !== undefined && title !== undefined;
			setShowFooter(hasAccess && isConfluenceLink(url));
			setCurrentCard({ url, title });
		});
		return unsub;
	}, [editorApi]);

	const onClose = useCallback(() => {
		setShowFooter(false);
		resetProactiveDescriptionCompleterPayload();
	}, [resetProactiveDescriptionCompleterPayload]);

	return (
		showFooter && (
			<DescriptionCompleter
				onClick={onProactiveDescriptionCompleterFooterClick}
				onClose={onClose}
			/>
		)
	);
};
